(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-customer-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCustomerReviewsSwiper() {
    document
      .querySelectorAll('.customer-reviews-swiper')
      .forEach(function (swiperEl) {

        if (swiperEl.classList.contains('swiper-initialized')) return;

        new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: true,
          allowTouchMove: true,
		  pagination: {
			  el: swiperEl.querySelector('.custom-swiper-pagination'),
				clickable: true,
			},
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          }
        });
      });
  }

  document.addEventListener('DOMContentLoaded', initCustomerReviewsSwiper);
  document.addEventListener('shopify:section:load', initCustomerReviewsSwiper);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-product-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initProductSliders() {
    document
      .querySelectorAll('.product-slider-section')
      .forEach(function (section) {
        const sliderEl = section.querySelector('.product-slider');
        if (!sliderEl || sliderEl.classList.contains('swiper-initialized')) {
          return;
        }

        new Swiper(sliderEl, {
          slidesPerView: 4,
          spaceBetween: 30,
          loop: true,
          navigation: {
            nextEl: section.querySelector('.custom-swiper-button-next'),
            prevEl: section.querySelector('.custom-swiper-button-prev')
          },
          breakpoints: {
            0: {
              slidesPerView: 1
            },
            640: {
              slidesPerView: 2
            },
            1024: {
              slidesPerView: 3
            }
          }
        });
      });
  }

  document.addEventListener('DOMContentLoaded', initProductSliders);

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', initProductSliders);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-slider-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initImageSlider() {
    document.querySelectorAll('.main-banner-swiper').forEach(function (swiperEl) {
      if (swiperEl.classList.contains('swiper-initialized')) return;

      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        grabCursor: true,
        allowTouchMove: true,
        speed: 1000,
        
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initImageSlider);
  document.addEventListener('shopify:section:load', initImageSlider);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-text-image-two-buttons"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initImageSlider() {
    document.querySelectorAll('.mySwiper').forEach(function (swiperEl) {
      
      if (swiperEl.classList.contains('swiper-initialized')) return;

      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        grabCursor: true,
        allowTouchMove: true,
        speed: 800,
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true,
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', initImageSlider);
  document.addEventListener('shopify:section:load', initImageSlider);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-top-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTopbarSwiper() {
    document
      .querySelectorAll('.custom-topbar-swiper')
      .forEach(function (swiperEl) {

        if (swiperEl.classList.contains('swiper-initialized')) return;

        new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 20,
          loop: true,
          allowTouchMove: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false
          }
        });
      });
  }

  document.addEventListener('DOMContentLoaded', initTopbarSwiper);
  document.addEventListener('shopify:section:load', initTopbarSwiper);
})();

  } catch(e) { console.error(e); }
})();
})();
